import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import BackLink from '../../../../common/back-link';
import PageTitle from '../../../../common/page-title';
import ScanViewDetails from './scan-view-details';
import { getScan } from '../../../../../actions/scans';

class ScanViewPage extends Component {
  componentDidMount() {
    const { match: { params: { id } }, dispatch } = this.props;

    dispatch(getScan(id));
  }

  render() {
    const { loading, scannerCode } = this.props;

    return (
      <div className="container-fluid">
        <Row>
          <Col>
            <BackLink href="/admin/scans" />
          </Col>
          <PageTitle>Scan details</PageTitle>
          {loading ? 'Loading...' : scannerCode.attributes && <ScanViewDetails scannerCode={scannerCode} />}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: !state.scans.fetched && state.scans.fetching,
  scannerCode: state.scans.scannerCode,
});

export default connect(mapStateToProps)(ScanViewPage);
